import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { PasswordInput } from '../components/PasswordInput';

export const Login: React.FC = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [showMigrationAlert, setShowMigrationAlert] = useState(true);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const user = await login(formData.email, formData.password);
      // Rediriger selon le rôle de l'utilisateur
      if (user.role === 'admin') {
        navigate('/admin');
      } else {
        navigate('/');
      }
    } catch (err: any) {
      setError(err.response?.data?.detail || err.response?.data?.error || 'Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const timer = window.setTimeout(() => setShowMigrationAlert(false), 60_000);
    return () => window.clearTimeout(timer);
  }, []);

  // const topBanner =
  //   showMigrationAlert && (
  //     <div className="fixed top-0 left-0 right-0 z-30">
  //       <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 pt-3">
  //         <div className="bg-gradient-to-r from-blue-600 via-blue-500 to-blue-600 text-white rounded-b-2xl shadow-lg border-b border-blue-300 animate-bounce-slow">
  //           <div className="px-4 py-3 flex items-start space-x-3">
  //             <div className="mt-0.5 text-xl">🔔</div>
  //             <div className="text-sm sm:text-base">
  //               <p className="font-semibold uppercase tracking-wide text-blue-100">
  //                 Information importante pour les anciens comptes
  //               </p>
  //               <p className="mt-1">
  //                 Tous les comptes déjà existants utilisent désormais le mot de passe temporaire{' '}
  //                 <span className="font-bold underline decoration-yellow-200 decoration-2">
  //                   Hanafiya2025!
  //                 </span>
  //                 .
  //               </p>
  //               <p className="mt-1 text-blue-100 text-xs sm:text-sm">
  //                 Après connexion, pensez à sécuriser votre compte en passant par « Mot de passe oublié ? » pour
  //                 définir votre propre mot de passe.
  //               </p>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   );

  const migrationAlert = showMigrationAlert && (
    <div className="bg-blue-50 border-2 border-blue-200 rounded-xl p-4 mb-6 animate-slide-down">
      <p className="text-blue-800 text-sm font-medium flex items-start space-x-2">
        <span className="text-lg">🔔</span>
        <span>
          <strong>Important :</strong> Tous les comptes existants utilisent désormais le mot de passe temporaire{' '}
          <strong className="bg-blue-100 px-2 py-1 rounded">Hanafiya2025!</strong>.
          <span className="text-xs text-blue-600 mt-2 block">
            Connectez-vous avec cet identifiant puis changez-le via « Mot de passe oublié ? » si nécessaire.
          </span>
        </span>
      </p>
    </div>
  );

  return (
    <div className="min-h-screen relative bg-gradient-to-br from-white via-green-50/30 to-green-100/50 overflow-hidden">
      {/* {topBanner} */}
      {/* Motifs décoratifs */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-20 -right-20 w-96 h-96 bg-green-200/20 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-20 -left-20 w-96 h-96 bg-green-300/20 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-72 h-72 bg-green-100/30 rounded-full blur-2xl"></div>
      </div>

      {/* Logo retour accueil en haut à gauche */}
      <div className="relative z-20 fixed top-4 left-4">
        <Link
          to="/"
          className="group flex items-center"
        >
          <div className="w-14 h-14 rounded-full border-[3px] border-green-600 shadow-xl overflow-hidden transform group-hover:scale-110 group-hover:rotate-3 transition-all duration-300 bg-white p-1.5">
            <img
              src="/logo.jpg"
              alt="Retour à l'accueil"
              className="w-full h-full rounded-full object-contain"
              style={{ objectPosition: 'center center' }}
            />
          </div>
        </Link>
      </div>

      <div className="relative z-10 flex items-center justify-center min-h-screen px-4 sm:px-6 lg:px-8 py-12">
        <div className="w-full max-w-5xl">
          {/* Layout desktop avec logo à gauche */}
          <div className="hidden lg:flex items-center gap-12 w-full">
            {/* Logo à gauche - desktop uniquement */}
            <div className="flex-shrink-0">
              <div className="w-96 h-96 rounded-full border-[3px] border-green-600 shadow-2xl overflow-hidden transform hover:scale-110 hover:rotate-3 transition-all duration-300 bg-white p-5 animate-pulse hover:animate-bounce">
                <img
                  src="/logo.jpg"
                  alt="Hanafia Logo"
                  className="w-full h-full rounded-full object-contain"
                  style={{ objectPosition: 'center center' }}
                />
              </div>
            </div>

            {/* Formulaire à droite */}
            <div className="flex-1 max-w-md ml-auto">
              <div className="bg-white/90 backdrop-blur-sm rounded-3xl shadow-2xl border border-green-100/50 p-8 sm:p-10">
            {/* Header */}
            <div className="text-center mb-8">
              
              <h1 className="text-4xl sm:text-5xl font-bold bg-gradient-to-r from-green-700 via-green-600 to-green-800 bg-clip-text text-transparent mb-3">
                Connexion
              </h1>
              <p className="text-gray-600 text-lg">
                Bienvenue sur <span className="font-semibold text-green-700">Hanafia</span>
              </p>
            </div>

            {/* Message d'information pour migration */}
            {migrationAlert}

            {/* Formulaire */}
            <form onSubmit={handleSubmit} className="space-y-6">
              {error && (
                <div className="bg-red-50 border-2 border-red-200 rounded-xl p-4 animate-slide-down">
                  <p className="text-red-700 text-sm font-medium flex items-center space-x-2">
                    <span>⚠️</span>
                    <span>{error}</span>
                  </p>
                </div>
              )}

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  📧 Email
                </label>
                <input
                  type="email"
                  required
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  className="w-full px-4 py-3 border-2 border-green-200 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all bg-white"
                  placeholder="votre@email.com"
                />
              </div>

              <div>
                <div className="flex items-center justify-between mb-2">
                  <label className="block text-sm font-semibold text-gray-700">
                    🔒 Mot de passe
                  </label>
                  <Link
                    to="/forgot-password"
                    className="text-sm text-green-600 hover:text-green-800 font-medium transition-colors"
                  >
                    Mot de passe oublié ?
                  </Link>
                </div>
                  <PasswordInput
                    value={formData.password}
                    onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                    placeholder="••••••••"
                    required
                    autoComplete="current-password"
                  />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white font-semibold py-4 rounded-xl transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none flex items-center justify-center space-x-2"
              >
                {loading ? (
                  <>
                    <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent"></div>
                    <span>Connexion...</span>
                  </>
                ) : (
                  <>
                    <span>Se connecter</span>
                    <span>→</span>
                  </>
                )}
              </button>
            </form>

            {/* Footer */}
            <div className="mt-8 text-center">
              <p className="text-gray-600 text-sm">
                Pas encore de compte ?{' '}
                <Link to="/register" className="text-green-700 font-semibold hover:text-green-800 transition-colors">
                  S'inscrire
                </Link>
              </p>
            </div>
              </div>
            </div>
          </div>

          {/* Layout mobile - sans logo à gauche */}
          <div className="lg:hidden w-full max-w-md">
            {/* Card de connexion */}
            <div className="bg-white/90 backdrop-blur-sm rounded-3xl shadow-2xl border border-green-100/50 p-8 sm:p-10">
              {/* Header */}
              <div className="text-center mb-8">
                <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-green-500 to-green-700 rounded-2xl mb-6 shadow-lg">
                  <span className="text-4xl">🕌</span>
                </div>
                <h1 className="text-4xl sm:text-5xl font-bold bg-gradient-to-r from-green-700 via-green-600 to-green-800 bg-clip-text text-transparent mb-3">
                  Connexion
                </h1>
                <p className="text-gray-600 text-lg">
                  Bienvenue sur <span className="font-semibold text-green-700">Hanafia</span>
                </p>
              </div>

              {/* Message d'information pour migration */}
              {migrationAlert}

              {/* Formulaire */}
              <form onSubmit={handleSubmit} className="space-y-6">
                {error && (
                  <div className="bg-red-50 border-2 border-red-200 rounded-xl p-4 animate-slide-down">
                    <p className="text-red-700 text-sm font-medium flex items-center space-x-2">
                      <span>⚠️</span>
                      <span>{error}</span>
                    </p>
                  </div>
                )}

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    📧 Email
                  </label>
                  <input
                    type="email"
                    required
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    className="w-full px-4 py-3 border-2 border-green-200 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all bg-white"
                    placeholder="votre@email.com"
                  />
                </div>

                <div>
                  <div className="flex items-center justify-between mb-2">
                    <label className="block text-sm font-semibold text-gray-700">
                      🔒 Mot de passe
                    </label>
                    <Link
                      to="/forgot-password"
                      className="text-sm text-green-600 hover:text-green-800 font-medium transition-colors"
                    >
                      Mot de passe oublié ?
                    </Link>
                  </div>
                  <PasswordInput
                    value={formData.password}
                    onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                    placeholder="••••••••"
                    required
                    autoComplete="current-password"
                  />
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white font-semibold py-4 rounded-xl transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none flex items-center justify-center space-x-2"
                >
                  {loading ? (
                    <>
                      <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent"></div>
                      <span>Connexion...</span>
                    </>
                  ) : (
                    <>
                      <span>Se connecter</span>
                      <span>→</span>
                    </>
                  )}
                </button>
              </form>

              {/* Footer */}
              <div className="mt-8 text-center">
                <p className="text-gray-600 text-sm">
                  Pas encore de compte ?{' '}
                  <Link to="/register" className="text-green-700 font-semibold hover:text-green-800 transition-colors">
                    S'inscrire
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
